import service from "../index";

export default {
    //    机器人留言配置
    getRobotConfig(data, url = '/api/v1/common/chat/mbotLeavingConf', method = 'get') {
        return service({
            url, method, data,
            isTourists: true,
            isCompany: true
        })
    },
    //    /api/v1/common/chat/sendQuestLeaving
    sendQuestLeaving(data, url = '/api/v1/common/chat/sendQuestLeaving', method = 'post') {
        return service({
            url, method, data,
            isTourists: true,
            isCompany: true
        })
    }
}
